import type systemPointId from "./id";

const systemPointEn: typeof systemPointId = {
	system_point: {
		title: "System Point",
		subtitle: "System point rules & rewards",
		table: {
			title: "Reward Data",
			empty_state: {
				title: "No reward data",
				description: "Please add a new reward.",
			},
			columns: {
				redeem_points: "Redeem Points",
				reward_type: "Reward Type",
				reward: "Reward",
				max_reward: "Maximum Reward",
				action: "Action",
			},
			types: {
				percent: "Discount (%)",
				amount: "Amount (Rp)",
			},
			points_unit: "points",
			delete_confirm: "Are you sure you want to delete this reward?",
			delete_success: "Reward deleted successfully",
			delete_error: "Failed to delete reward",
		},
		rule_modal: {
			trigger: "Set Loyalty Program",
			title: "Loyalty Program",
			description:
				"Customers will receive certain points from the total purchase amount on each transaction.",
			active: "Active",
			inactive: "Inactive",
			fields: {
				amount: "Spending",
				amount_placeholder: "Rp 0",
				points: "Points Earned",
				points_placeholder: "0 points",
				is_multiple: "Apply multiples?",
			},
			cancel: "Cancel",
			save: "Save",
		},
		reward_modal: {
			trigger: "Add Reward",
			title: "Add Reward",
			select_label: "Select reward for points redemption",
			types: {
				discount: {
					title: "Discount (%)",
					description:
						"Customers will receive a % discount from the total purchase when redeeming a certain number of points.",
				},
				amount: {
					title: "Deduction (Rp)",
					description:
						"Customers will receive a certain price deduction when redeeming a certain number of points.",
				},
			},
			fields: {
				redeem_points: "Points to redeem",
				reward_discount: "Discount amount earned",
				max_discount: "Maximum discount",
				reward_amount: "Deduction amount earned",
			},
			cancel: "Cancel",
			save: "Save",
		},
	},
};

export default systemPointEn;
